import repository from '@/repositories/Repository'

const resource = '/api/pfv'

/**
 * PFVデータリポジトリ
 */
export default {
  /**
   * PFVクラスターデータを取得する
   *
   * @param {String} company 企業コード
   */
  get(company) {
    return repository.giggle.get(`${resource}/${company}`).then(r => r.data)
  },
  /**
   * 掲載する画像URLを取得する
   */
  getImageUrls(company) {
    return repository.giggle
      .get(`${resource}/${company}/images`)
      .then(r => r.data)
  },
  /**
   * クラスタ名を変更する
   *
   * @param {String} company 企業コード
   * @param {String} clusterCode 名称変更対象のコード
   * @param {String} newName 新しい名称
   */
  post(company, clusterCode, newName) {
    return repository.giggle
      .post(`${resource}/${company}/${clusterCode}`, newName)
      .then(r => r.data)
  },
}
